import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { useSeriesWidgetContext } from "~/components/article/article-left-hand-side-widgets/series-widget/contexts";
import { tracking } from "~/data";
import type { seriesWidgetEntrypointHeadlineArticle$key } from "~/queries/__generated__/seriesWidgetEntrypointHeadlineArticle.graphql";

import {
  Container,
  Headline,
  HeadlineContainer,
  HighlightText,
  Indicator,
  StyledEntityLink,
} from "./styles";

export type Props = {
  className?: string;
  reference: seriesWidgetEntrypointHeadlineArticle$key;
  total: number;
};

export const SeriesWidgetEntrypointHeadline: FunctionComponent<Props> = ({ reference, total }) => {
  const article = useFragment(
    graphql`
      fragment seriesWidgetEntrypointHeadlineArticle on Article {
        seriesContainer {
          ...entityLink
          headline
        }
      }
    `,
    reference,
  );
  const { campaign, currentItemIndex } = useSeriesWidgetContext();

  return article.seriesContainer ? (
    <StyledEntityLink
      query={{
        campaign,
        module: tracking.module.SeriesLHSHeader,
        pgtype: tracking.pageType.Article,
      }}
      reference={article.seriesContainer}
    >
      <Container>
        <HeadlineContainer>
          <HighlightText>SCMP Series</HighlightText>
          <Headline>{article.seriesContainer?.headline ?? ""}</Headline>
        </HeadlineContainer>
        <Indicator>
          <strong>{currentItemIndex + 1}</strong> of {total}
        </Indicator>
      </Container>
    </StyledEntityLink>
  ) : null;
};

SeriesWidgetEntrypointHeadline.displayName = "SeriesWidgetEntrypointHeadline";
